import { useQuery } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'
import { TxReporting } from '@fortem-monorepo/web-sdk'

export const useTxReportQuery = (params: TxReporting.GetTxReportParams) => {
  const api = useApi()

  return useQuery({
    queryKey: ['tx-reporting', 'report', params],
    queryFn: () => api.txReporting.getReport(params),
  })
}
